import LocalStorage from './storages/localStorage.js';

const storageTypes = {
    localStorage: LocalStorage,
    default: LocalStorage
};

Object.freeze(storageTypes);
export default storageTypes;
